import {
    ADD_ITEM,
    CHANGE_ITEM,
    DELETE_ITEM,
    FETCH_ITEM_LIST,
    FETCH_ITEM_LIST_ERROR,
    FETCH_ITEM_LIST_SUCCESS,
    SET_MONTH,
    SET_QUARTER,
    SET_TYPE,
    SET_YEAR,
    UPDATE_ITEM
} from 'items/actions/types'
import {apiAction} from 'apa/actions'
import {push} from 'connected-react-router'
import {fetchInvoices} from 'invoices/actions/invoices'

export const changeMonth = (month, callback = false) => dispatch => {
    dispatch(
        {
            type: SET_MONTH,
            currentMonth: month
        }
    )
    if (callback) {
        callback(null, month, null)
    } else {
        dispatch(fetchItemList())
    }
}

export const changeYear = (year, callback = false) => dispatch => {
    dispatch(
        {
            type: SET_YEAR,
            currentYear: year
        }
    )
    if (callback) {
        callback(year, null, null)
    } else {
        dispatch(fetchItemList())
        dispatch(fetchInvoices())
    }
}

export const changeQuarter = (quarter, callback = false) => dispatch => {
    dispatch(
        {
            type: SET_QUARTER,
            currentQuarter: quarter
        }
    )
    if (callback) {
        callback(null, null, quarter)
    } else {
        dispatch(fetchItemList())
    }
}

export const setCurrentType = (type) => dispatch => {
    dispatch({
        type: SET_TYPE,
        currentType: type
    })
    dispatch(fetchItemList())
}

export const fetchItemList = () => (dispatch, getState) => {
    dispatch({
        type: FETCH_ITEM_LIST
    })
    const {
        currentYear,
        currentQuarter,
        currentType,
        currentMonth
    } = getState().items

    const data = {
        year: currentYear,
        quarter: currentQuarter,
        month: currentMonth,
        type: currentType
    }
    dispatch(apiAction({
        url: 'https://apabackend.quixtest.de/api/items/',
        data: data,
        onSuccess: itemList => ({
            type: FETCH_ITEM_LIST_SUCCESS,
            itemList: itemList
        }),
        onFailure: errors => ({
            type: FETCH_ITEM_LIST_ERROR,
            errors: errors
        })
    }))
}

export const add = (item, history) => (dispatch) => dispatch(
    apiAction({
        url: '/api/items/',
        method: 'POST',
        data: item,
        onSuccess: (item) => {
            dispatch(fetchItemList())
            history.push('/items')
            return {
                type: ADD_ITEM,
                payload: item
            }
        }
    })
)

export const update = (item) => dispatch => dispatch(
    apiAction({
        url: `/api/items/${item.id}/`,
        method: 'PATCH',
        data: item,
        onSuccess: (item) => {
            dispatch(fetchItemList())
            dispatch(push('/items'))
            return {
                type: UPDATE_ITEM,
                payload: item
            }
        }
    }))

export const remove = (item_id) => dispatch => dispatch(
    apiAction({
        url: `/api/items/${item_id}/`,
        method: 'DELETE',
        onSuccess: () => {
            dispatch(fetchItemList())
            return {
                type: DELETE_ITEM,
                payload: item_id
            }
        }
    })
)

export const change = (item) => (dispatch, getState) => {
    const items = getState().invoices.items
    const itemIndex = items.findIndex(
        (i) => i.id === item.id
    )
    items.splice(itemIndex, 1, item)
    return dispatch({
        type: CHANGE_ITEM,
        items: items
    })
}
